import axios from 'axios';
// ----------------------------------------------------------------------

export const axiosInstance = axios.create();

if (process.env.REACT_APP_BACKEND_MODE === 'PROD') {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_PROD;
} else if (process.env.REACT_APP_BACKEND_MODE === 'UAT') {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_UAT;
} else {
  axiosInstance.defaults.baseURL = process.env.REACT_APP_API_LOCAL;
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) =>
    Promise.reject(
      (error.response && error.response.data) || 'Something went wrong',
    ),
);

export const endpoint = {
  translation: {
    root: '/translation',
  },
  employee: {
    root: '/employee',
    option: '/employee/option',
    hris: '/employee-hris',
    guru_option: '/employee_guru/option',
    guru_mapel: '/guru-mapel',
    tugas_mapel: '/tugas-guru-mapel',
  },
  employee_guru: {
    root: 'employee_guru',
    option: 'employee_guru/option',
  },
  jenjang: {
    root: '/jenjang',
    option: '/jenjang/option',
  },
  jurusan: {
    root: '/jurusan',
    sync: '/jurusan/sync',
    option: '/jurusan/option',
  },
  jurusanSp: {
    root: '/jurusan-sp',
    sync: '/jurusan-sp/sync',
  },
  alokasiWalikelas: {
    root: '/alokasi-walikelas',
  },
  kelas: {
    root: '/kelas',
    sync: '/kelas/sync',
    option: '/kelas/option',
  },
  kelasSp: {
    root: '/kelas-sp',
    option: '/kelas-sp-option',
    sync: '/kelas-sp/sync',
    fase: '/kelas-sp-fase',
    by_pengajar: '/kelas-by-pengajar',
  },
  login: 'login',
  register: 'register',
  user: {
    root: 'user',
    option: '/user/option',
    by_token: 'user/by-token',
    role: 'user/role',
    change_password: 'user/change-password',
    reset_password: 'user/reset-password',
  },
  parameter: {
    root: '/parameter',
    option: '/parameter/option',
    gradep5: '/parameter_gradeP5',
  },

  application: {
    root: '/application',
    option: '/application/option',
    role: '/application/role',
    menu: '/application/menu',
  },
  menu: {
    root: '/menu',
    option: '/menu/option',
    action: '/menu/action',
  },
  action: {
    root: '/action',
    option: '/action/option',
    approver: '/action/approver',
    role: '/action/role',
  },
  parallel: {
    root: '/parallel',
    sync: '/parallel/sync',
    option: '/parallel/option',
    penilaian: '/parallel-penilaian',
    rapor: '/parallel-rapor',
  },
  parallelSp: {
    root: '/parallel-sp',
    sync: '/parallel-sp/sync',
    duplicate: '/parallel-sp-duplicate',
    penilaian: '/parallel-sp-penilaian',
    pengajar: '/parallel-sp-by-pengajar',
    jurnal: '/parallel-sp-jurnal',
  },
  parent: {
    root: '/parent',
    option: '/parent/option',
    student: '/parent/student',
  },
  role: {
    root: '/role',
    detail: '/role/id',
    option: '/role/option',
    application: '/role/application',
    priviledge: '/role/priviledge',
    user: '/role/user',
    approval: '/role/approval',
  },
  school: {
    root: '/school',
    option: '/school/option',
  },
  student: {
    root: '/student',
    sync: '/student/sync',
    option: '/student/option',
    option_ledger: '/student/option-ledger',
    parent: '/student/parent',
    mutation: '/student/mutation',
    sibling: '/student/sibling',
    siblingoption: '/student-siblings',
    presence: '/student-presence',
    presenceReport: '/student-presence-report',
    presence_upload: '/student-presence-upload',
    presence_upload_delete: '/student-presence-upload-delete',
    presence_rekap: '/student-presence-rekap',
    presence_individu: '/student-presence-individu',
    withEkskul: '/student_ekskul',
    withEkskulReport: '/student-ekskul-report',
    withEkskulReportExcel: '/student-ekskul-report-excel',
    withEkskulWajib: '/student_ekskul_wajib',
    withMapil: '/mapil-student',
    nonActive: '/student-non-active',
    nonActiveUpload: '/student-non-active-upload',
    by_announcement: 'student-by-announcement',
    manual_mutation: 'student-manual-mutation',
    manual_mutation_cancel: 'student-manual-mutation-cancel',
    withPresence: 'student-with-presence',
    presence_request: 'presence-request',
    incident: 'catatan-kesiswaan',
    incident_read: 'catatan-kesiswaan-read',
    incidentExcel: 'catatan-kesiswaan-excel',
    incident_upload: 'catatan-kesiswaan-upload',
    incident_upload_delete: 'catatan-kesiswaan-upload-delete',
    withMapilWajib: 'student-mapil-wajib',
    downloadRekapMapil: 'mapil-student-rekap',
    changePassword: 'student-change-password',
    presence_new: 'student-presence-new',
    presence_upload_new: 'student-presence-upload-new',
    presence_upload_delete_new: 'student-presence-upload-delete-new',
    presence_log: 'student-presence-log',
    presence_today: 'student-presence-today',
  },
  tahun_pelajaran: {
    root: '/tahun-pelajaran',
    option: '/tahun-pelajaran/option',
  },
  tahun_pelajaran_sp: {
    root: '/tahun-pelajaran-sp',
    updateActive: '/tahun-pelajaran-sp-update-active',
  },
  semester_sp: {
    root: '/semester-sp',
    updateActive: '/semester-sp-update-active',
  },
  unit: {
    root: '/unit',
    option: '/unit/option',
    unitWithClass: '/unit-kelas',
    unitShow: '/unitShow',
  },
  kikd: {
    filterKi: '/kikd/ki',
    ki: '/kikd/ki',
    kiById: '/kikd/ki/filterById',
    kiStatus: '/kikd/ki/update-status',
    kd: '/kikd/kd',
    jenjang: '/kikd/jenjang',
    indikator: 'kikd/indikator',
    kiOption: '/kikd/kiOption',
  },
  mapel: {
    root: '/mapel',
    tujuan_pembelajaran: '/tujuan_pembelajaran',
    ekskul: '/mapel_ekskul',
    ekskulNew: '/mapel-ekskul-new',
    mapel_intrakurikuler: 'mapel-intrakurikuler',
    kesenian: 'mapel-kesenian',
    keterampilan: 'mapel-keterampilan',
    alokasi_kesenian: 'mapel-kesenian-alokasi',
    alokasi_kesenian_download: 'mapel-kesenian-alokasi-download',
    alokasi_keterampilan: 'mapel-keterampilan-alokasi',
    alokasi_keterampilan_download: 'mapel-keterampilan-alokasi-download',
    alokasi_ekskul_new: 'alokasi-ekskul-new',
    alokasi_ekskul_download: 'alokasi-ekskul-download',
    jam: 'jam-mapel',
    export: 'mapel-export',
    jurnal: 'mapel-jurnal',
  },
  ranah: {
    root: '/ranah',
  },
  prosem: {
    root: '/prosem',
    updateStatus: '/prosem/updateStatus',
  },
  prota: {
    root: '/prota',
    updateStatus: '/prota/updateStatus',
  },
  semester: {
    root: 'semester',
    option: 'semester/option',
  },
  silabus: {
    root: '/silabus',
    updateStatus: '/silabus/updateStatus',
  },
  kegiatanPembelajaran: {
    root: '/kegiatan-pembelajaran',
  },
  bentukPenilaian: {
    root: '/bentuk-penilaian',
  },
  jenisPenilaian: {
    root: '/jenis-penilaian',
  },
  sumatif: {
    root: '/sumatif',
    oneData: '/sumatif/one-sumatif',
    sumatifKd: '/sumatif/kd',
    sumatifIndikator: '/sumatif/indikator',
    sumatifIndikatorDelete: '/sumatif/indikatorByIdKd',
    updateStatus: '/sumatif/updateStatus',
  },
  tipeSoal: {
    root: '/tipe-soal',
  },
  tingkatKesulitan: {
    root: '/tingkat-kesulitan',
  },
  indikatorSoal: {
    root: '/indikator-soal',
    image: '/indikator-soal/image-upload',
  },
  penguatanKarakter: {
    root: '/penguatan-karakter',
  },
  keterampilanHidup: {
    root: '/keterampilan-hidup',
  },
  moralConfucius: {
    root: '/moral-confucius',
  },
  rpp: {
    root: '/rpp',
    byFilter: '/rpp-byFilter',
    updateStatus: '/rpp/updateStatus',
    saveAs: '/rpp/save-as',
    exportFile: '/rpp/export',
  },
  rbm: {
    root: '/rencana-bulanan',
    rencanaMingguan: '/rencana-mingguan',
    updateStatus: '/rencana-bulanan/updateStatus',
  },
  alokasiWaktu: {
    root: '/alokasi-waktu',
    rootJp: '/alokasi-waktu-jp',
  },
  penjadwalan: {
    root: '/penjadwalan-pengisian',
    all: '/penjadwalan-pengisian-all',
    category: 'penjadwalan-pengisian-category',
  },
  status: {
    root: '/status',
  },
  comment: {
    root: '/comment',
  },
  tempStudent: {
    root: '/temp-student',
    downloadFile: '/temp-student/export',
    importFile: '/temp-student/import',
  },
  bukuInduk: {
    root: '/buku-induk',
    sync: '/buku-induk/sync',
    syncPSB: '/buku-induk/syncPsb',
    root_search: '/buku-induk-search',
    syncPSBManual: '/buku-induk/syncPsb-manual',
  },
  bukuPanduan: {
    root: '/buku-panduan',
    update: '/buku-panduan/update',
    formPernyataan: '/buku-panduan/formPernyataan',
  },
  ekskul: {
    root: 'ekskul',
    category: 'ekskul_category',
    categoryByKelas: 'ekskul_category_kelas',
    detail: 'ekskul_detail',
    byKelas: 'ekskul/detail',
    student: 'ekskul_student',
    student_update: 'ekskul_student_update',
    student_update_batch: 'ekskul-student-update-batch',
    kelas: 'ekskul_kelas',
    byUser: 'ekskulByUser',
    pengajar: 'ekskul_pengajar',
    byPengajar: 'ekskul-by-pengajar',
    pengajar_siswa: 'pengajar_ekskul_siswa',
    year: 'ekskul_year',
    setting_teacher: 'ekskul_teacher',
    pengajar_update: 'ekskul_student_update_pengajar',
    pengajar_update_batch: 'ekskul_student_update_pengajar_batch',
    student_wajib: 'ekskul_student_wajib',
    note: 'ekskul-note',
    note_all: 'ekskul-note-all',
    penilaian: 'ekskul-penilaian',
    ekskul_kelas: 'ekskul-kelas',
    student_pengajar: 'student-ekskul-pengajar',
    presence: 'ekskul-presence',
  },
  intrakurikuler: {
    ruang_lingkup_materi: {
      root: 'ruang_lingkup_materi',
      detail: 'ruang_lingkup_materi_detail',
      penilaian: 'penilaian-sumatif',
      penilaian_akhir: 'penilaian-sumatif-akhir',
      penilaian_akhir_default: 'penilaian-sumatif-akhir-default',
      penilaianByStudent: 'penilaian-sumatif-by-student',
      report_penilaian: 'report-nilai-sumatif',
      report_penilaian_excel: 'report-nilai-sumatif-excel',
      report_penilaian_as: 'report-nilai-sumatif-as',
      report_penilaian_as_excel: 'report-nilai-sumatif-as-excel',
      show_parent: 'ruang-lingkup-materi-show-parent',
      show_student: 'ruang-lingkup-materi-show-student',
      mapel: 'mapels-formatif',
      delete_nilai: 'penilaian-sumatif-delete',
      export: 'ruang-lingkup-materi-export',
    },
    tujuan_pembelajaran: {
      root: 'tujuan_pembelajaran_kb',
      detail: 'tujuan_pembelajaran_kb_detail',
      penilaian: 'penilaian-formatif',
      report_penilaian: 'report-nilai-formatif',
      report_penilaian_excel: 'report-nilai-formatif-excel',
      jumlah_penilaian: 'tujuan_pembelajaran_kb_jumlah_penilaian',
      penilaianByStudent: 'penilaian-formatif-by-student',
      deskripsi: 'tujuan_pembelajaran_kb_deskripsi',
      show_parent: 'tujuan-pembelajaran-show-parent',
      show_student: 'tujuan-pembelajaran-show-student',
      penilaian_formatif_sumatif: 'penilaian-formatif-sumatif',
      penilaian_interfensi: 'penilaian-interfensi',
      mapel: 'mapels-sumatif',
      by_ruang_lingkup: 'tujuan-pembelajaran-by-ruang-lingkup',
      kktp: 'tujuan-pembelajaran-kktp',
      delete_nilai: 'penilaian-formatif-delete',
      all: 'tujuan_pembelajaran_all',
      export: 'tujuan-pembelajaran-export',
    },
    upload_materi: 'upload-materi',
    update_attachment_materi: 'update-attachment-materi',
    delete_batch_materi: 'delete-batch-materi',
    rapor_sumatif_formatif: 'student-rapor-sumatif-formatif',
    student_excercise: 'student-excercise',
    student_excercise_attachment: 'student-excercise-attachment',
    student_excercise_answer: 'student-excercise-answer',
    penilaian_nus: 'penilaian-nus',
  },
  general_ledger: {
    root: 'general-ledger',
    byMapel: 'general-ledger-mapel',
    byStudent: 'general-ledger-student',
    byClass: 'general-ledger-kelas',
    generatePdf: 'generate-pdf-ledger',
    generateExcel: 'generate-excel-ledger',
    generateLengkapExcel: 'generate-lengkap-ledger',
    kelulusan: 'general-ledger-kelulusan',
  },
  dimensi: {
    root: 'dimensi',
    option: 'dimensi/option',
  },
  duplicate_master_p5: 'duplicate-master-p5',
  user_access_setting: 'user-access-jenjang',
  rapor: {
    root: 'rapor-sumatif-formatif',
    generateByUser: 'generate-sumatif-formatif-by-user',
    generateByUserSD: 'generate-sumatif-formatif-by-user-sd',
    generateByUserSD2: 'generate-sumatif-formatif-by-user-sd-2',
    generateByClass: 'generate-sumatif-formatif-by-class',
    generateByClassSD: 'generate-sumatif-formatif-by-class-sd',
    generateByClassSD2: 'generate-sumatif-formatif-by-class-sd-2',
    generateByUser2: 'generate-sumatif-formatif-by-user-2',
    generateByClass2: 'generate-sumatif-formatif-by-class-2',
    generateByClassTK: 'generate-rapor-by-class-tk',
    generateByUserTK: 'generate-rapor-by-user-tk',
    urutan_rapor: 'urutan-rapor',
    setting_tanggal: 'rapor-date',
    setting_show: 'rapor-show-setting',
    setting_show_mid: 'rapor-mid-show-setting',
    generateMidByUser: 'generate-mid-semester',
    generateMidByClass: 'generate-mid-semester-byclass',
    generateRaporP5ByUser: 'generate-raporp5-by-user',
    setting_nilai_rapor: 'rapor-grade-setting',
    generateRaporP5ByClass: 'generate-raporp5-by-class',
    setting_nilai_rapor_duplicate: 'rapor-grade-setting-duplicate',
    nilai_rapor_5: 'nilai-rapor-5',
    setting_persentase_kelulusan: 'setting-persentase-kelulusan',
    nilai_kelulusan: 'nilai-kelulusan',
  },
  alokasiGuruP5: {
    root: '/alokasi-gurup5',
    option: '/alokasi-gurup5/option',
  },
  elemen: {
    root: 'elemen',
    option: 'elemen/option',
  },
  subelemen: {
    root: 'subelemen',
    option: 'subelemen/option',
  },
  catatan_proses: {
    catatan_proses: 'catatan_proses',
  },
  catatan_proses_template: {
    root: 'catatan_proses_template',
    option: 'catatan_proses_template/option',
  },
  penilaian_proyek: {
    penilaian_proyek: 'penilaian_proyek',
  },
  proyek: {
    root: 'proyek',
    option: 'proyek/option',
    judul_proyek: 'proyek_judul',
    student: 'proyek_student',
    proyek_dimensi: 'proyek_dimensi',
    capaian_fase: 'capaian_fase',
  },

  profile_sekolah: {
    root: 'profile-sekolah',
  },
  kepala_sekolah: {
    root: 'kepala-sekolah',
  },
  aspect: {
    root: '/aspect',
    copy: '/aspect/copy',
    option: '/aspect/option',
    by_param: '/aspect/by_param',
    sub: '/aspect/sub',
    export: 'aspect-export',
  },
  indicator: {
    root: '/indicator_aspect',
    copy: '/indicator_aspect/copy',
    option: '/indicator_aspect/option',
    term_option: '/indicator_aspect/term_option',
    export: 'indicator-aspect-export',
  },
  assesment_indicator: {
    root: '/assesment_indicator_aspect',
    option: '/assesment_indicator_aspect/option',
  },
  assesment_category: {
    root: '/assesment_category',
    option: '/assesment_category/option',
  },
  chinese_name_setting: {
    root: '/chinese_name_setting',
    option: '/chinese_name_setting/option',
  },
  assesment_naration: {
    root: '/assesment_naration',
    copy: '/assesment_naration/copy',
    option: '/assesment_naration/option',
  },
  weekly_assesment: {
    root: '/weekly_assesment',
    student: '/weekly_assesment/student',
    report: {
      teacher: '/weekly_assesment/report/teacher',
      teacher_to_xls: '/weekly_assesment/report/teacher/xls',
      by_student_to_xls: '/weekly_assesment/report/by_student/xls',
      parent: '/weekly_assesment/report/parent',
      parent_to_xls: '/weekly_assesment/report/parent/xls',
    },
  },
  indicator_allocation: {
    root: '/indicator_aspect_allocation',
    option: '/indicator_aspect_allocation/option',
    selected: '/indicator_aspect_allocation/selected',
    aspect_option: '/indicator_aspect_allocation/aspect/option',
    indicator_option: '/indicator_aspect_allocation/indicator/option',
    class_option: '/indicator_aspect_allocation/class/option',
  },
  teacher_assignment: {
    root: '/teacher_assignment',
    option: '/teacher_assignment/option',
    copy: '/teacher_assignment/copy',
    selected: '/teacher_assignment/selected',
    aspect: '/teacher_assignment/aspect',
    aspect_option: '/teacher_assignment/aspect/option',
    indicator_option: '/teacher_assignment/indicator/option',
    class_option: '/teacher_assignment/class/option',
    paralel_option: '/teacher_assignment/paralel/option',
    export: 'teacher-assignment-export',
  },
  term: {
    root: '/term',
    option: '/term/option',
    detail: '/term/detail',
  },
  mapelpilihanwajib: {
    root: '/daftar-mapel-pilihan-wajib',
    tahunpelajaran: '/tahun-pelajaran',
    jenjang: '/jenjang/option',
    pelajaran: '/mata-pelajaran',
    kelaspilih: '/kelas-pilih',
    storekuotamapelwajib: '/mapil-wajib-simpan',
    updatekuotamapelwajib: '/mapil-wajib-update',
    changeMapel: 'mapel-pilihan-wajib-change',
  },
  cover: {
    tk: '/cover-raport-tk',
    sd: '/cover-raport-sd',
    smp: '/cover-raport-smp',
    sma: '/cover-raport-sma',
  },
  prestasi_siswa: 'prestasi-siswa',
  catatan_walikelas: 'catatan-walikelas',
  catatan_walikelas_batch: 'catatan-walikelas-batch',
  mapelpilihanwajibsiswa: {
    rekapmapel: '/rekap-mapel-wajib-siswa',
    rekapsiswabymapel: '/rekap-siswa-by-mapel-pilihan',
    rekapsiswabyExcel: '/rekap-siswa-by-mapel-by-excel',
    approvalwalikelas: '/approval-walikelas-mapel-pilihan-siswa',
    mapelpilihanbysiswa: '/daftar-mapel-pilihan-bysiswa',
    cetakpdf: '/cetak-mapel-pilihan-siswa-pdf',
    rekapAllSiswabyExcel: '/rekap-all-siswa-by-mapel-by-excel',
    rekapAllKelasbyExcel: '/rekap-all-kelas-by-mapel-by-excel',
  },
  jadwalpilihanwajib: {
    root: '/jadwal-pilihan-wajib',
    optionjenisjadwal: '/option-jenis-jadwal',
    jadwalstore: '/jadwal-mapel-pilihan-store',
    jadwalupdate: '/jadwal-mapel-pilihan-update',
    jadwalmapelaktif: '/jadwal-mapel-aktif',
  },
  information: {
    root: '/information',
    detail: '/information-detail',
    attachment: '/information-attachment',
    byUser: '/information-byuser',
    updateRead: '/information-update-read',
  },
  gallery: {
    root: '/gallery',
    detail: '/gallery-detail',
    attachment: '/gallery-attachment',
    byUser: '/gallery-byuser',
    updateRead: '/gallery-update-read',
  },
  rapat_rumpun: {
    root: '/rapat-rumpun',
    jenis: '/rapat-rumpun-type',
    pembahasan: '/rapat-rumpun-pembahasan',
    byuser: '/rapat-rumpun-byuser',
  },
  setting_buka_tutup: {
    root: 'setting-buka-tutup',
  },
  calendar: {
    root: 'calendar',
    option: 'calendar/option',
    update: 'calendar',
    delete: 'calendar/delete',
    report2pdf: 'calendar_pdf',
    updateStatus: 'calendar/updStatus',
  },
  tugasGuru: {
    getMapelByNIK: 'tugasguru/bynik',
    getNIKPerMapel: 'tugasguru/bymapel',
    getNIKPerKelas: 'tugasguru/bykelas',
  },
  agendaGuru: {
    root: 'agendaguru',
    hapus: 'agendaguru/delete',
    getStudent: 'agendaguru/getStudent',
    getNIKGuru: 'agendaguru/getNIK',
    getAgendaGuruAbsen: 'agendaguru_absen',
    jurnal: 'agendaguru/jurnal',
    jurnal_pdf: 'agendaguru_jurnal_pdf',
  },
  mapil: {
    kelas: 'mapil-kelas',
  },
  rombel: {
    root: 'rombel',
  },
  perusahaan: {
    root: '/perusahaan',
    option: '/perusahaan/option',
  },
  jadwalpelajaran: {
    root: 'jadwal',
    jadwalByParallel: 'jadwal-by-parallel',
    option: 'jadwal/option',
    sesi: 'jadwal/sesike',
    jamkelas: 'jadwal/jamkelas',
    jadwalkelas: 'jadwal_pelajaran/per_kelas',
    upload: 'jadwal-pelajaran-upload',
    upload_active: 'jadwal-pelajaran-active',
    ulangan: 'jadwal-ulangan',
    show_jadwal_ulangan: 'jadwal-ulangan-show',
    acc_jadwal_ulangan: 'jadwal-ulangan-acc',
    tanggal_ulangan_pas: 'tanggal-ulangan-pas',
    jadwal_ulangan_pas: 'jadwal-ulangan-pas',
    delete_jadwal_ulangan: 'delete-jadwal-ulangan',
    delete_jadwal_ulangan_pas: 'delete-jadwal-ulangan-pas',
  },
  jadwalguru: {
    root: 'jadwalguru',
  },
};
